import styled from 'styled-components'

const PageHeader = styled.section`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.gray2};
  padding: 10px 15px;
`

export default PageHeader
